'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoCommentDiscussion = function GoCommentDiscussion(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 20v-7.5h-7.5s-2.5 1.3-2.5 2.5v12.5s1.3 2.5 2.5 2.5h2.5v7.5l7.6-7.5h7.5s2.4-1.2 2.4-2.5v-2.5h-7.5s-5-2.5-5-5z m22.5-15h-17.5s-2.5 1.3-2.5 2.5v12.5s1.3 2.5 2.5 2.5h7.4l7.6 7.5v-7.5h2.5s2.5-1.2 2.5-2.5v-12.5s-1.2-2.5-2.5-2.5z' })
        )
    );
};

exports.default = GoCommentDiscussion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/comment-discussion.js
// module id = 1655
// module chunks = 0